var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7d6afe;\n      }\n\n      .cls-2 {\n        fill: #00b4ff;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #ff9e7c;\n      }\n\n      .cls-5 {\n        stroke: #e7edfd;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {\n        fill: none;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-12, .cls-13, .cls-14, .cls-15, .cls-19, .cls-20 {\n        stroke-linecap: round;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-12, .cls-13, .cls-14, .cls-15, .cls-19, .cls-20 {\n        stroke-linejoin: round;\n      }\n\n      .cls-5, .cls-6, .cls-13 {\n        stroke-width: 3px;\n      }\n\n      .cls-21 {\n        fill: #5143d0;\n      }\n\n      .cls-6 {\n        stroke: #b8b2ff;\n      }\n\n      .cls-7 {\n        stroke: #de7d65;\n        stroke-width: 1.04px;\n      }\n\n      .cls-22 {\n        fill: #fafafa;\n      }\n\n      .cls-8, .cls-9, .cls-10, .cls-11, .cls-16, .cls-18 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8, .cls-10, .cls-12, .cls-16 {\n        stroke: #e8edfe;\n      }\n\n      .cls-8, .cls-20 {\n        stroke-width: 2px;\n      }\n\n      .cls-23 {\n        fill: #8683ed;\n      }\n\n      .cls-9 {\n        stroke-width: 1.86px;\n      }\n\n      .cls-9, .cls-11 {\n        stroke: #5a58ae;\n      }\n\n      .cls-10 {\n        stroke-width: .9px;\n      }\n\n      .cls-24 {\n        isolation: isolate;\n      }\n\n      .cls-11 {\n        stroke-width: 2px;\n      }\n\n      .cls-12 {\n        stroke-width: .62px;\n      }\n\n      .cls-25 {\n        fill: #9598ff;\n      }\n\n      .cls-26, .cls-27 {\n        fill: #a695ff;\n      }\n\n      .cls-28 {\n        fill: #00004c;\n      }\n\n      .cls-29 {\n        fill: #ff4173;\n      }\n\n      .cls-30 {\n        fill: #f6e2e0;\n      }\n\n      .cls-13, .cls-15, .cls-19 {\n        opacity: .37;\n        stroke: #736af8;\n      }\n\n      .cls-31 {\n        fill: #6234fb;\n      }\n\n      .cls-32 {\n        fill: #ffeef7;\n      }\n\n      .cls-33 {\n        fill: #b8b2ff;\n      }\n\n      .cls-34 {\n        fill: #e7edfd;\n      }\n\n      .cls-27 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-27, .cls-35 {\n        opacity: .14;\n      }\n\n      .cls-14 {\n        stroke: #ff9e7c;\n        stroke-width: .61px;\n      }\n\n      .cls-36 {\n        fill: #b2aeff;\n      }\n\n      .cls-37 {\n        fill: #968cf4;\n      }\n\n      .cls-38, .cls-39 {\n        fill: #e8edfe;\n      }\n\n      .cls-40 {\n        fill: #d84655;\n      }\n\n      .cls-41 {\n        fill: #7d6aff;\n      }\n\n      .cls-42 {\n        fill: #ffbba5;\n      }\n\n      .cls-43 {\n        fill: #dee4ff;\n      }\n\n      .cls-15 {\n        stroke-width: 2.05px;\n      }\n\n      .cls-4 {\n        opacity: .33;\n      }\n\n      .cls-44 {\n        fill: #8b85f5;\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-18 {\n        stroke-width: 1.48px;\n      }\n\n      .cls-18, .cls-20 {\n        stroke: #00004c;\n      }\n\n      .cls-19 {\n        stroke-width: 1.02px;\n      }\n\n      .cls-46 {\n        fill: #5b3fda;\n      }\n\n      .cls-47 {\n        fill: #736af8;\n      }\n\n      .cls-39 {\n        font-family: ChangaOne, ChangaOne;\n        font-size: 24.9px;\n      }\n\n      .cls-48 {\n        fill: #000067;\n      }\n\n      .cls-49 {\n        fill: #b63847;\n      }\n\n      .cls-50 {\n        fill: #01b2ff;\n      }\n\n      .cls-51 {\n        fill: #95a1ff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    width: 750,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m19.63,429.65c-6.67-21.57-8.91-47.41,5.77-64.56,21.7-25.35,63.65-15.35,93.44-30.39,26.93-13.59,39.27-45.16,45.13-74.74,5.87-29.58,7.96-60.99,23.63-86.76,7.66-12.61,19.63-23.94,34.32-25.36,29.68-2.87,47.33,32.73,74.16,45.75,25.36,12.32,56.68,2.39,78.63-15.32,21.94-17.71,37.27-42.08,55.17-63.86,21.22-25.81,48.23-49.24,81.08-55.34,32.85-6.1,71.56,10.75,80.55,42.94,11.59,41.49-27.72,88.16-7.69,126.3,11.54,21.97,37.95,30.55,61.49,38.4,27.31,9.11,56.71,20.42,70.8,47.58,11.35,21.88,8.6,51.65-9.96,67.87-7.85,6.86-17.73,10.93-26.23,16.97-8.49,6.05-16,15.35-15.18,25.75.72,9.23,7.83,16.76,15.67,21.7,7.83,4.94,16.7,8.1,24.32,13.36,12.93,8.92,21.49,23.89,22.63,39.55.83,11.45-2.51,29.72-12.08,37.5-8.6,6.98-22.47,3.55-33.07,3.41-32.36-.43-64.71-.86-97.07-1.29-63.86-.85-127.78-2.54-191.64-2.54-52.43-.7-104.87-1.39-157.3-2.09-26.22-.35-52.43-.7-78.65-1.04-18.79-.25-41.83,3.41-60.24-.66-18.52-4.09-34.54-25.93-45.31-40.19-13.58-17.97-27.48-40.63-32.35-62.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m150.67,253.85c.55-6.67.05-13.94-4.17-19.15-4.33-5.35-11.89-7.34-18.69-6.29s-12.94,4.72-18.3,9.03c-20.24,16.27-32.84,42.84-57.2,51.81-7.23,2.66-15.1,3.55-21.96,7.05-6.86,3.49-12.74,10.9-10.95,18.39,1.71,7.16,9.37,11.06,16.42,13.13,50.06,14.7,110.39-19.93,114.85-73.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m682.3,201.74c-8.52,4.04-14.13,13.02-15.39,22.37-1.26,9.35,1.43,18.94,6.17,27.1,3.24,5.59,7.67,10.81,13.62,13.32,9.12,3.85,20.35.21,26.78-7.31,6.43-7.53,8.44-18.16,6.93-27.94-2.83-18.32-17.11-37.49-38.12-27.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m371.49,152.93c-9.37,6.89-19.91,13.1-31.52,13.69-11.61.59-24.29-6.12-27-17.42-2.8-11.69,5.79-23.43,16.19-29.46,10.4-6.03,22.55-8.15,33.72-12.61,21.22-8.47,38.73-25.83,47.37-46.98,3.45-8.44,8.12-19.32,17.22-18.74,20.71,1.33,5.4,40.46.73,50.55-10.91,23.58-36.16,45.86-56.7,60.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m493.05,36.89c5.24,16.01.78,33.58-5.84,49.07-6.62,15.49-15.42,30.21-19.35,46.58-3.93,16.38-1.93,35.58,10.4,47.05,8.45,7.86,20.46,10.88,32,10.95,11.54.07,22.91-2.5,34.29-4.42,41.34-6.99,84.1-5.46,124.84,4.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m510.47,31.06c4.78,12.89,1.94,27.31-2.3,40.39-4.25,13.08-9.91,25.96-10.75,39.68-.84,13.72,4.5,28.99,16.83,35.06,12.06,5.93,26.33,1.5,39.35-1.8,32.23-8.19,66.35-8.82,98.86-1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m539.85,35.12c5.64,7.54,4.43,18.28.75,26.95-3.68,8.66-9.49,16.33-12.79,25.15s-3.51,19.83,3.06,26.56c5.42,5.56,13.86,6.71,21.63,6.89,26.67.62,53.48-6.62,76.2-20.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m101.27,527.77c-17.26-14.78-31.95-32.56-43.2-52.3-5.47-9.6-9.78-22.67-2.29-30.8,6.76-7.34,18.49-5.57,28.37-4.15,19.4,2.78,39.82,1.75,57.61-6.47,19.06-8.81,33.49-24.97,48.22-39.94,14.73-14.96,31.33-29.68,51.85-34.13,20.52-4.45,45.52,5.32,51.01,25.59,3.66,13.54-2.03,27.97-10.1,39.44-8.07,11.47-18.52,21.15-26.28,32.83-19.61,29.51-18.88,71.12,1.75,99.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m137.68,531.42c-15.51-12.38-29.17-27.07-40.41-43.42-4.76-6.93-9.16-16.06-4.89-23.3,3.48-5.91,11.38-7.64,18.18-6.8,6.8.84,13.26,3.62,20.07,4.37,15.58,1.73,30.29-7.22,42.37-17.21,12.08-9.99,23.39-21.66,38.07-27.17,8.38-3.14,19.02-3.58,25.08,3,5.87,6.38,4.87,16.45,2.1,24.66-6.36,18.86-19.66,34.4-30.55,51.06-10.89,16.66-19.78,36.52-15.63,55.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m148.91,494.69c-.11-4.58,0-9.32,1.93-13.47s6.18-7.55,10.74-7.12c6.84.63,10.17,8.62,11.24,15.4,1.4,8.9,2.83,64.44-10.53,65.74-10.2.99-13.16-51.81-13.38-60.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m735.74,493.95c-10.34-18.91-29.53-30.03-48.82-36.55-19.29-6.52-39.55-9.39-58.58-16.8-11.23-4.37-23.44-12.58-24.26-25.55-.85-13.35,10.62-23.15,17.35-34.34,6.1-10.14,8.54-22.46,14.48-32.71,8.94-15.44,25.04-24.61,41.46-28.23,16.42-3.63,33.37-2.38,50.08-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m743.28,353.99c-28.87-6.68-60.38,1.81-83.07,22.39-8.11,7.35-15.55,17.38-15.17,28.87.42,12.52,10.03,22.46,20.22,28.26,22.29,12.7,48.69,12.21,73.83,11.42"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m73.01,339.67c4.87,3.55,7.3,9.84,7.03,15.86-.26,6.02-2.96,11.74-6.67,16.48-9.03,11.53-23.5,17.4-37.73,20.82-14.24,3.42-29.01,4.93-42.7,10.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m51.36,345.59c4.12,6.58,3.51,15.42-.3,22.19-3.81,6.76-10.4,11.62-17.51,14.75s-14.78,4.69-22.39,6.23"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m769.29,484.78c-2.26-2.45-5.65-3.71-7.72-6.32-4.03-5.06-1.54-12.53-2.84-18.87-1.12-5.43-5.11-9.92-9.8-12.88-4.69-2.96-10-4.66-15.3-6.27,5.94,8.79,6.27,21.05.79,30.14-.45.75-1.05,1.55-1.92,1.64-1.37.14-2.18-1.5-2.4-2.86-.61-3.89.3-7.84,1.11-11.7.81-3.86,1.51-7.89.49-11.7-1.02-3.81-4.09-7.74-8.03-7.8,0,3.5.9,6.93,1.31,10.41.41,3.48.27,7.21-1.61,10.17-1.88,2.96-5.93,4.73-9.04,3.11-3.39-1.77-4.05-6.42-3.24-10.16.81-3.74,2.64-7.31,2.63-11.13,0-5.44-3.94-10.39-8.92-12.59-4.97-2.2-10.93-2.37-16.16-.86,2.2,6.58,4.09,13.27,5.66,20.03.4,1.7.77,3.46.46,5.18-.32,1.72-1.5,3.4-3.21,3.75-1.69.35-3.42-.69-4.41-2.11-.99-1.42-1.39-3.15-1.76-4.83-.78-3.45-1.55-6.91-2.33-10.36-.48-2.14-1.15-4.53-3.09-5.54-1.5-.78-3.37-.46-4.87.32-1.5.78-2.73,1.98-4.05,3.03-6.94,5.56-16.73,7.31-25.16,4.49,5.39,4.24,8.24,11.48,7.19,18.25-.69,4.47-2.91,9.13-1.13,13.28,1.13,2.62,3.69,4.4,6.41,5.25,2.72.86,5.61.92,8.46.97,5.54.1,11.08.21,16.63.31,4.12.08,9.25.85,10.52,4.78,1.23,3.81-2.33,7.49-5.92,9.26-11.1,5.47-25.46,1.97-32.97-7.88-.38,10.25,6.21,20.4,15.73,24.22-1.5,5.26,1.62,11.41,6.75,13.31,5.57,2.06,11.79-.66,16.56-4.21,4.77-3.55,8.98-8.05,14.5-10.26,2.77-1.11,6.53-1.31,8.19,1.17,1.08,1.62.82,3.79.22,5.65-2.07,6.35-7.52,11.14-13.57,13.95-6.05,2.81-12.74,3.91-19.33,4.98,2.7,3.81,7.08,6.16,11.6,7.31,4.52,1.15,9.24,1.23,13.91,1.3,5.1.08,10.25.14,15.22-.98,4.97-1.12,9.82-3.57,12.86-7.67,5.55-7.48,6.32-19.4,4.2-28.47,5.45.66,8.41,3.18,13.84,2.34,5.43-.85,10.82-3.38,13.94-7.9,3.12-4.52,3.35-11.21-.38-15.25Zm-95.37-16.06c-.03,1.18-1.39,1.78-2.52,2.11-1.91.55-3.83,1.1-5.81,1.25-1.98.15-4.04-.13-5.75-1.15-1.15-.68-2.18-2.03-1.68-3.27.26-.65.87-1.08,1.47-1.42,3.92-2.24,9.62-2.27,13.25.72.54.45,1.05,1.05,1.04,1.76Zm4.1-14.14c.07.55.07,1.17-.29,1.6-.37.45-1.03.57-1.59.43-.56-.14-1.04-.51-1.46-.9-1.2-1.1-2.12-2.49-2.66-4.02-.22-.62-.38-1.29-.2-1.92,1.06-3.75,5.97,3.14,6.2,4.82Zm22.02,15.89c-.29.7-.84,1.35-1.59,1.49-1.09.2-2.03-.71-2.75-1.54-1.43-1.64-4.45-7.12-.06-7.19,3.23-.05,5.51,4.54,4.4,7.24Zm14.05,3.07c1.19-2.71,3.09-1.27,4.19.52.53.86.83,1.9.61,2.88-.22.98-1.05,1.86-2.06,1.93-1.19.08-2.19-.93-2.66-2.03-.44-1.04-.54-2.26-.09-3.3Zm5.22,23.26c1.35.3,2.62,1.2,2.09,2.69-.72,2.01-3.72,1.94-5.37,1.72-4.83-.64.27-5.1,3.28-4.42Zm13.03,31.79c-.75,1.33-2.04,2.27-3.42,2.92-1.58.74-3.31,1.16-5.05,1.21-1.26.04-2.75-.28-3.22-1.44-.4-.98.15-2.08.8-2.92,1.84-2.36,4.79-3.7,7.78-3.83,2.74-.13,4.69,1.26,3.12,4.06Zm19.38-33.18c-1.98,1.34-3.59,3.25-6.08,1.84-2.32-1.31-2.45-3.98-1.24-6.06.31-.53.69-.99,1.11-1.38,1.64-1.53,3.98-2.21,5.88-3.46,1.3-.85,2.62-3.01,4.36-1.98,4.32,2.56-1.73,9.48-4.02,11.04Zm-.24-23.49c-.57,2.78-2.02,5.78-4.76,6.51-.68.18-1.44.19-2.04-.18-.66-.41-.99-1.21-1.01-1.99-.03-.77.21-1.53.45-2.27.89-2.65,1.97-5.26,2.42-8.02.29-1.76.29-3.58-.14-5.32-.2-.81-1.14-2.3-.81-3.14,1.25-3.24,4.66,1.23,5.15,2.67,1.27,3.75,1.53,7.84.74,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m655.07,446.05c6.38,8.88,15.52,15.41,25.06,20.75,9.54,5.34,19.63,9.66,29.11,15.12,28.31,16.29,50.2,42.16,78.64,58.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m743.43,391.03s.9-37.09,11.11-32.49c10.22,4.59-3.78,26.52-11.11,32.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m743.33,390.57s-33.46-16.02-34-4.83c-.54,11.19,25.35,8.66,34,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m752.66,409.87s-32.49-17.9-33.67-6.76c-1.18,11.14,24.82,10.09,33.67,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m758.81,433.63s-28.81-23.37-31.94-12.62c-3.13,10.75,22.64,14.33,31.94,12.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m762.22,459.15s-27.01-25.43-30.92-14.93,21.52,15.96,30.92,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m734.19,374.85s-10.27-38.06.05-38.21c10.32-.16,4.6,28.7-.05,38.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m734.5,373.52s-35.06-18.01-37.38-7.95c-2.32,10.06,27.1,10.5,37.38,7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m721.53,356.68s-17.72-33.12-7.65-35.15c10.07-2.03,10.28,25.55,7.65,35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m722.03,356.15s-33.99-15.98-35.49-5.81c-1.5,10.17,26.05,8.94,35.49,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m705.38,336.99s-13.55-29.38-5.71-31.24c7.84-1.87,7.82,22.68,5.71,31.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m705.38,336.99s-29.65-12.94-31.36-5.07c-1.71,7.87,22.84,7.35,31.36,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m761.79,460.77s2.84-68.05-67.7-135.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m698.55,330.31s-29.84-15.62-24.56-22.14c5.28-6.52,20.86,13.74,24.56,22.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.21,483.19s7.36-36.36-3.62-34.15c-10.98,2.21-2.21,26.7,3.62,34.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.41,482.77s36.18-8.19,34.22,2.84c-1.96,11.03-26.64,2.82-34.22-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m-2.98,499.51s35.66-10.23,34.33.89-26.44,4.33-34.33-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m22.81,469.47s18.46-34.83,8.44-37.27c-10.03-2.45-10.85,26.96-8.44,37.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m22.8,468.1s38.19-9.77,38.21.55c.02,10.32-28.75,4.22-38.21-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m39.19,454.56s24.64-28.36,15.26-32.57c-9.37-4.21-15.7,22.63-15.26,32.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m38.82,453.93s36.69-8.03,35.9,2.21c-.8,10.25-27.38,2.93-35.9-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m59.31,438.95s19.74-25.63,12.51-29.2-12.66,20.38-12.51,29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m59.31,438.95s31.78-6.03,31.7,2.02-23.9,2.09-31.7-2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m-23.17,547.11s12.34-66.98,96.01-116.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m67.45,433.95s32.56-8.61,28.86-16.13c-3.7-7.53-23.39,8.77-28.86,16.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m276.38,43.1c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m292.13,43.1c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m307.88,43.1c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m323.63,43.1c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m339.38,43.1c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m276.38,58.85c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m292.13,58.85c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m307.88,58.85c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m323.63,58.85c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m339.38,58.85c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m276.38,74.6c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m292.13,74.6c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m307.88,74.6c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m323.63,74.6c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m339.38,74.6c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m612.79,202.48c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m628.54,202.48c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m644.29,202.48c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m612.79,218.23c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m628.54,218.23c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m644.29,218.23c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m49.63,76.98c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m65.38,76.98c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m49.63,92.73c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m65.38,92.73c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m49.63,108.48c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m65.38,108.48c0,.51-.41.92-.92.92s-.92-.41-.92-.92.41-.92.92-.92.92.41.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m591.94,418.25c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m591.94,434c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m576.19,418.25c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m576.19,434c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m560.44,418.25c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m560.44,434c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.83,225.71c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.83,241.46c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m83.08,225.71c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m83.08,241.46c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m714.72,51.89c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m714.72,67.64c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m698.97,51.89c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m698.97,67.64c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m173.24,432.03c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m173.24,447.78c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m157.49,432.03c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m157.49,447.78c-.51,0-.92-.41-.92-.92s.41-.92.92-.92.92.41.92.92-.41.92-.92.92Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m418.55,202.54l-.42-3.78c-.09-.79-.8-1.36-1.59-1.27l-2.32.26c-.6.07-1.18-.24-1.45-.78-.41-.85-.91-1.65-1.5-2.39-.37-.47-.4-1.13-.07-1.64l1.24-1.97c.42-.67.22-1.56-.45-1.99l-3.21-2.03c-.67-.42-1.56-.22-1.99.45l-1.24,1.97c-.32.51-.93.77-1.52.64-.45-.1-.92-.18-1.39-.24-.47-.05-.94-.08-1.41-.08-.6,0-1.14-.4-1.33-.97l-.77-2.2c-.26-.75-1.08-1.15-1.84-.89l-3.59,1.25c-.75.26-1.15,1.08-.89,1.84l.77,2.2c.2.57.03,1.21-.44,1.59-.73.59-1.41,1.25-2,1.99-.38.47-1.02.64-1.58.44l-2.2-.77c-.75-.26-1.57.13-1.84.88l-1.26,3.58c-.26.75.13,1.57.88,1.84l2.2.77c.57.2.96.73.96,1.33,0,.96.11,1.9.31,2.8.13.59-.13,1.19-.65,1.51l-1.98,1.24c-.67.42-.88,1.31-.46,1.99l2.02,3.22c.42.67,1.31.88,1.99.46l1.98-1.24c.51-.32,1.17-.3,1.64.08.73.58,1.53,1.09,2.38,1.5.54.26.85.85.78,1.45l-.26,2.32c-.09.79.48,1.51,1.27,1.6l3.77.43c.79.09,1.51-.48,1.6-1.27l.26-2.32c.07-.6.5-1.1,1.09-1.24.93-.21,1.82-.52,2.66-.93.54-.26,1.19-.13,1.62.29l1.65,1.65c.56.56,1.47.57,2.04,0l2.69-2.68c.56-.56.57-1.47,0-2.04l-1.65-1.65c-.43-.43-.55-1.08-.29-1.62.4-.84.72-1.73.93-2.66.14-.59.64-1.02,1.24-1.08l2.32-.26c.79-.09,1.36-.8,1.27-1.59Zm-18.18,7.15c-3.94-.45-6.77-4-6.32-7.94.45-3.94,4-6.77,7.94-6.32s6.77,4,6.32,7.94c-.45,3.94-4,6.77-7.94,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m280.88,147.06l.3-1.36c.06-.29-.12-.57-.4-.63l-.84-.18c-.22-.05-.38-.22-.41-.44-.04-.35-.12-.68-.24-1.01-.07-.21,0-.44.17-.58l.67-.54c.23-.18.26-.52.08-.75l-.88-1.09c-.18-.23-.52-.26-.75-.08l-.67.54c-.17.14-.42.16-.6.04-.15-.09-.3-.17-.46-.25-.16-.07-.32-.14-.48-.2-.21-.07-.35-.27-.35-.49v-.86c0-.29-.25-.53-.54-.53h-1.4c-.29.01-.53.25-.53.54v.86c0,.22-.13.42-.34.5-.33.12-.64.27-.93.46-.19.12-.43.1-.6-.04l-.67-.53c-.23-.18-.56-.14-.74.09l-.86,1.1c-.18.23-.14.56.09.74l.68.53c.17.14.25.37.18.58-.11.33-.19.67-.22,1.01-.02.22-.19.4-.4.45l-.83.2c-.28.07-.46.35-.39.64l.32,1.36c.07.29.35.46.64.39l.83-.2c.22-.05.44.04.56.22.19.29.4.56.65.81.16.16.19.4.1.6l-.37.78c-.13.26-.01.58.25.71l1.26.6c.26.13.58.01.71-.25l.37-.78c.09-.2.3-.32.52-.3.35.04.7.03,1.04,0,.22-.03.43.09.53.29l.38.77c.13.26.45.37.71.24l1.25-.62c.26-.13.37-.45.24-.71l-.38-.77c-.1-.2-.06-.44.09-.6.24-.24.45-.52.64-.82.12-.19.34-.28.56-.23l.84.19c.29.06.57-.12.63-.4Zm-7.18.34c-1.32-.62-1.88-2.2-1.26-3.52s2.2-1.88,3.52-1.26c1.32.62,1.88,2.2,1.26,3.52-.62,1.32-2.2,1.88-3.52,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m629.37,333.15l1.46-6.61c.31-1.39-.57-2.76-1.95-3.06l-4.06-.9c-1.05-.23-1.86-1.09-1.99-2.15-.21-1.67-.59-3.31-1.16-4.89-.36-1.01-.02-2.14.82-2.82l3.23-2.62c1.1-.89,1.27-2.51.38-3.61l-4.26-5.26c-.89-1.1-2.51-1.27-3.61-.38l-3.23,2.62c-.84.68-2.01.77-2.93.21-.7-.43-1.44-.83-2.21-1.2s-1.54-.68-2.32-.95c-1.02-.35-1.69-1.32-1.69-2.4l-.03-4.16c-.01-1.42-1.17-2.56-2.59-2.55l-6.77.05c-1.42.01-2.56,1.17-2.55,2.59l.03,4.16c0,1.07-.65,2.05-1.66,2.42-1.58.57-3.09,1.31-4.51,2.21-.91.57-2.08.49-2.92-.17l-3.27-2.57c-1.12-.88-2.73-.68-3.61.43l-4.18,5.32c-.88,1.12-.68,2.73.43,3.61l3.27,2.57c.84.66,1.21,1.79.86,2.8-.55,1.61-.91,3.26-1.09,4.9-.12,1.07-.91,1.94-1.96,2.18l-4.04.95c-1.38.33-2.24,1.71-1.91,3.09l1.55,6.59c.33,1.38,1.71,2.24,3.09,1.91l4.04-.95c1.05-.25,2.15.18,2.73,1.08.9,1.4,1.96,2.71,3.16,3.9.76.75.94,1.92.48,2.89l-1.77,3.75c-.61,1.28-.06,2.81,1.22,3.42l6.12,2.89c1.28.61,2.81.06,3.42-1.22l1.77-3.75c.46-.97,1.47-1.57,2.54-1.46,1.68.17,3.37.16,5.02-.04,1.07-.13,2.09.46,2.57,1.42l1.83,3.73c.62,1.27,2.16,1.8,3.44,1.18l6.08-2.98c1.27-.62,1.8-2.16,1.17-3.44l-1.83-3.73c-.47-.96-.31-2.13.45-2.9,1.16-1.18,2.2-2.5,3.1-3.95.57-.91,1.66-1.35,2.71-1.11l4.06.9c1.39.31,2.76-.57,3.06-1.95Zm-34.76,1.63c-6.39-3.02-9.11-10.63-6.09-17.02,3.02-6.39,10.63-9.11,17.02-6.09,6.39,3.02,9.11,10.63,6.09,17.02-3.02,6.39-10.63,9.11-17.02,6.09Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 325.83,
    cy: 97.59,
    r: 5.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 697,
    cy: 164.95,
    r: 5.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 491.17,
    cy: 442.76,
    r: 5.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 258.71,
    cy: 207.95,
    r: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m534.67,185.55c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m410.73,241.86c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 399.08,
    cy: 436.88,
    r: 2.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 172.33,
    cy: 93.64,
    r: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m576.54,46.04c0,1.11-.9,2.01-2.01,2.01s-2.01-.9-2.01-2.01.9-2.01,2.01-2.01,2.01.9,2.01,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m60.08,164.95c0,2.22-1.8,4.01-4.01,4.01s-4.01-1.8-4.01-4.01,1.8-4.01,4.01-4.01,4.01,1.8,4.01,4.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 475.47,
    cy: 100.35,
    r: 4.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m341.13,183.57c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m352.23,183.57c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 362.23,
    cy: 183.57,
    r: 1.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 196.9,
    cy: 219.93,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 208.01,
    cy: 219.93,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m220.21,219.93c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m560.31,270.47c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 570.31,
    cy: 270.47,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m582.51,270.47c0,.61-.49,1.1-1.1,1.1s-1.1-.49-1.1-1.1.49-1.1,1.1-1.1,1.1.49,1.1,1.1Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 261.41,
    y: 169.51,
    width: 28.37,
    height: 15.25,
    rx: 3.69,
    ry: 3.69,
    transform: "translate(551.19 354.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 279.7,
    y: 182.55,
    width: 4.41,
    height: 4.41,
    transform: "translate(350.59 514.73) rotate(-135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 282.66,
    cy: 177.13,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 275.59,
    cy: 177.13,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 268.53,
    cy: 177.13,
    r: 2.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m371.43,326.46s-12.07,1.76-16.61,2.73c-4.54.97-23.76,17.53-22.05,18.69s10.06,5.44,15.14,3.8c5.08-1.64,4.11-5.47,11.2-4.78,7.09.69,15.47-6.1,15.47-6.1l46.63-24.93-6.75-16.91-43.03,27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m473.95,186.64c-4.91,10.24-6.07,24.61,1.94,28.45,8.02,3.84,22.18-4.3,27.09-14.54,4.91-10.24,2.38-21.66-5.63-25.5-8.02-3.84-18.49,1.35-23.4,11.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m469.57,214.25s3.66,15.9-10.65,20.35l-3.68,23.2,36.79,2.26,2.83-29.71s-4.71-14.94-3.87-29.38l-21.42,13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m494.86,230.36s-1.71,16.03-27.08,22.82h27.08s3.45-16.41,0-22.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m440.24,305.07l1.7-65.08s-8.21,1.41-13.87,14.15c-5.66,12.73-16.98,38.77-16.98,38.77l-50.29,32.74,14.5,16.73c11.48-5.83,51.91-16.85,64.93-37.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m375.31,342.38c11.48-5.83,51.91-16.85,64.93-37.31l1.04-39.87c-3.17,11.24-6.86,22.4-13.42,32-7.36,10.78-17.97,19-29.43,25.25-3.05,3.05-9.77,4.88-13.7,6.55-4.67,1.98-9.41,3.78-14.18,5.52-.38.14-.97.29-1.65.47l6.41,7.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "519.08 355.75 524.76 394.99 437.7 394.99 434.63 350.97 519.08 355.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m434.63,358.94l2.07,21.77s13.71-15.68,17.08-29.74l-19.15,7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m487.74,360.76s8.21,22.7,36.32,29.33l-2.63-18.17-33.69-11.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "475.05 371.92 478.95 394.99 474.09 394.99 475.05 371.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m437.7,353.74s19.29,9.6,70.54,6.35c-.25-1.75-13.38-120.1-13.38-120.1,0,0-6.11,10.6-20.77,10.6s-15.84-11.49-15.84-11.49c0,0-21.84,92.25-20.54,113.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m508.24,360.09c-.13-.89-3.6-32.03-6.97-62.38-23.3,6.89-47.13,2.49-55.85.41-4.48,22.68-8.29,45.38-7.72,54.72v.9s19.29,9.6,70.54,6.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m433.41,174.59c1.62,11.25,8.48,17.25,17.42,17.25s16.2-8.6,16.2-19.21-7.25-19.21-16.2-19.21c-12.05,0-18.94,10.67-17.42,21.17Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 504.54,
    cy: 161.11,
    rx: 19.35,
    ry: 21.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 508.69,
    cy: 181.61,
    rx: 7.06,
    ry: 6.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m489.65,205.98l-19.69,11.31c.15,2.67-.07,6.67-2.04,10.28,4.72-1.63,17.28-5.23,21.73-21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m492.77,197.94c-3.32,10.78-10.3,27.3-29.42,27.31-15.2,0-30.61-34.68-18.1-59.29,4.82-9.49,15.3-15.65,42.5-2.41,7.81,3.8,5.02,34.38,5.02,34.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m447.2,162.06s3.64,24.9,35.46,17.38l-1.83-12.14-33.64-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m487.75,162.68s-16.34,12.78,2.14,27.7c13.76,11.11,23.92-27.04-2.14-27.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m486.52,200.49c3.44,3.09,8.99,2.52,12.38-1.26,3.39-3.78,3.35-9.35-.09-12.44-3.44-3.09-8.99-2.52-12.38,1.26-3.39,3.78-3.35,9.35.09,12.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m462,189.39c.06,1.11.71,1.97,1.46,1.93.74-.04,1.3-.97,1.24-2.08-.06-1.11-.71-1.97-1.46-1.93-.74.04-1.3.97-1.24,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m446.97,191.1c.06,1.11.71,1.97,1.46,1.93s1.3-.97,1.24-2.08c-.06-1.11-.71-1.97-1.46-1.93s-1.3.97-1.24,2.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m461.61,212.63c-2.82.64-5.09-1.3-6.44-2.91-.89-1.01-1.39-1.93-1.39-1.93,0,0,5.68.32,12.35-5.54,0,0,2.54,8.79-4.53,10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m466.14,202.24c-2.29,6.21-8.03,7.32-10.97,7.47-.89-1.01-1.39-1.93-1.39-1.93,0,0,5.68.32,12.35-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m466.14,202.24c-2.29,6.21-8.03,7.32-10.97,7.47-.89-1.01-1.39-1.93-1.39-1.93,0,0,5.68.32,12.35-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m461.61,212.63c2.86-.64,4.13-2.46,4.65-4.4-1.28-.47-3.09-.36-4.87.43-1.79.79-3.09,2.06-3.59,3.33,1.1.62,2.38.96,3.81.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m455.16,189.73c-.3,3.56-1.85,7-4.32,9.57,1.21,1.32,2.83,2.27,4.57,2.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m467.78,184.78c-1.47-1.82-3.97-2.73-6.26-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m450.15,181.81c-1.97-.62-4.3.22-5.42,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m493.94,188.76c-1.97.46-3.68,1.89-4.49,3.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m445.92,155.95s.61,31.64,39.62,21.56l18.44.84c1.78-16.05,1.96-11.92-5.27-21.02-16.93-21.31-47.38-17.09-52.79-1.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m464.62,231.6l-22.68,8.38s-9.06,29.71-12.17,37.07c-3.11,7.36,7.36,32.82,9.05,42.73,1.7,9.9-11.88,33.39-11.6,64.23,0,0,11.11-12.64,21.95-26.79,10.85-14.15,11.15-42.26,6.06-60.93-5.09-18.68,9.38-64.69,9.38-64.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m494.86,230.36s-15.28,36.5-15.56,60.56c-.28,24.05-19.86,81,59.99,98.19,0,0-17.26-55.46-16.41-83.48.85-28.01,7.64-61.97,7.64-61.97l-35.65-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m478.66,299.93c-2.75,27.06-10.46,73.87,60.62,89.18,0,0-17.26-55.46-16.41-83.48.09-3.06.26-6.19.48-9.33l-6.46-19.74c-2.65,27.23-33.4,25.35-38.23,23.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m477.27,314.65c-.24,3.63-.37,7.4-.26,11.25l.14.31s14.39,6.75,28.32,14c13.89,7.23,31.25,48.11,31.35,48.34.81.19,1.62.38,2.46.55,0,0-10.88-34.96-14.94-63.39l-47.07-11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m449.18,357.23c10.17-13.26,11.07-38.78,6.95-57.3-10.22,1.71-21.5,1.79-26.08-12.17l2.24,9c2.47,8.74,5.66,17.94,6.53,23.03,1.7,9.9-11.88,33.39-11.6,64.23,0,0,11.11-12.64,21.95-26.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m434.79,279.98l31.93,6.53c2.16.44,3.84,2.15,4.24,4.31l7.55,40.39c.76,4.07-3.13,7.45-7.06,6.13l-22.88-7.7c-1.47-.49-2.66-1.6-3.26-3.02l-16.6-39.22c-1.7-4.02,1.8-8.3,6.08-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m431.98,279.98l31.93,6.53c2.16.44,3.84,2.15,4.24,4.31l7.55,40.39c.76,4.07-3.13,7.45-7.06,6.13l-22.88-7.7c-1.47-.49-2.66-1.6-3.26-3.02l-16.6-39.22c-1.7-4.02,1.8-8.3,6.08-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m482.2,324.07s-13.25,1.03-16.4.08c-3.15-.95-7.06-7.43-8.52-9.49-1.46-2.06.33-2.61.33-2.61,0,0-.81-.62-2.17-2-1.35-1.36,1.02-2.49,1.02-2.49-.82-.54-.92-1.41-.52-1.95.58-.8,1.96-.48,1.96-.48-.82-.59-.82-2.7,2.64-1.9,3.57.83,8.38,2.89,8.38,2.89l4.93.44-1.41-7.63s8.95,3.75,13.27,10.14l15.78,6.46s1.71,10.97-1.59,17.72c0,0-14.16-8.75-17.68-9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m487.74,323.79c-4.08-1.33-3.31-1.29-14.8-.46-9.29.67-11.99-3.57-13.13-4.99,1.78,2.48,4.03,5.21,5.99,5.8,3.15.95,16.4-.08,16.4-.08,1.33.16,4.2,1.52,7.23,3.14-.02-1.44-.35-2.98-1.7-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m457.9,305.12s6.92,3.71,8.17,4.38c1.24.67,2.84.63,2.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m456.46,307.56s6.75,5.48,7.92,6.21c1.18.73,6.77,1.75,6.77,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m457.61,312.05s6.62,6.78,8.34,7.39c1.73.61,5.21,1.12,5.21,1.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m544.41,345.04c11-3.88,9.5-27.15,5-50.65-9.03-47.16-18.9-50.74-18.9-50.74-29.64,4.42-12.08,59.09-7.23,73.03-5.33-2.45-33.83-6.96-33.83-6.96-3.42-1.15-7.58,14.95-2.79,17.48,10.38,5.47,42.6,19.17,57.75,17.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m523.28,316.69s8.38,2.27,14.38,6.02c0,0-5.62-6-15.94-10.66l1.56,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m544.41,345.04c9.31-3.28,9.66-20.45,6.83-39.89,4.8,33.63-15.83,34.3-29.52,30.06-13.4-4.16-36.23-12.21-37.18-12.54.16,2.11.8,3.84,2.12,4.54,10.38,5.47,42.6,19.17,57.75,17.83Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m355.38,384.44h57.34v5.58h-57.34c-.76,0-1.37-.62-1.37-1.37v-2.83c0-.76.62-1.37,1.37-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m412.99,384.44l36.54,3.18c.62.05,1.09.57,1.09,1.19h0c0,.66-.54,1.2-1.2,1.2h-36.54c-.66,0-1.2-.54-1.2-1.2v-3.18c0-.7.6-1.26,1.3-1.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m244.76,358.94h156.97c6.81,0,11.85-6.34,10.32-12.98l-25.24-109.33c-1.11-4.81-5.39-8.21-10.32-8.21h-156.97c-6.81,0-11.85,6.34-10.32,12.98l25.24,109.33c1.11,4.81,5.39,8.21,10.32,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m237.14,358.94h156.97c6.81,0,11.85-6.34,10.32-12.98l-25.24-109.33c-1.11-4.81-5.39-8.21-10.32-8.21h-156.97c-6.81,0-11.85,6.34-10.32,12.98l25.24,109.33c1.11,4.81,5.39,8.21,10.32,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m290.48,316.21c.17-2.45,2.21-4.35,4.67-4.35h24.75c.59,0,1.07.48,1.07,1.07h0c0,.59-.48,1.07-1.07,1.07h-1.52c-.5,0-.91.38-.94.88l-4.64,65.77c-.23,3.25,2.35,6.01,5.6,6.01h15.52c.95,0,1.71.77,1.71,1.71h0c0,.95-.77,1.71-1.71,1.71h-43.63c-2.71,0-4.86-2.3-4.67-5.01l4.86-68.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m639.88,394.99H110.13c-1.35,0-2.45-1.1-2.45-2.45h0c0-1.35,1.1-2.45,2.45-2.45h529.75c1.35,0,2.45,1.1,2.45,2.45h0c0,1.35-1.1,2.45-2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m659.29,394.99h-8.77c-1.35,0-2.45-1.1-2.45-2.45h0c0-1.35,1.1-2.45,2.45-2.45h8.77c1.35,0,2.45,1.1,2.45,2.45h0c0,1.35-1.1,2.45-2.45,2.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 168.42,
    cy: 365.22,
    rx: 15.43,
    ry: 1.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m165.79,362.83c.13-3.64,1.12-7.36,3.45-10.16,3.98-4.79,11.1-6.15,14.89-11.09,2.32-3.02,3.47-7.4,7.05-8.71,3.22-1.18,6.65.81,10.05,1.24,2.32.29,4.69-.16,7.01.12,2.32.28,4.81,1.63,5.25,3.93.52,2.71-2.04,5.05-4.6,6.1-2.56,1.05-5.48,1.51-7.49,3.4-2.19,2.06-2.8,5.36-4.85,7.56-3.5,3.74-9.71,3.03-14.06,5.73-6.03,3.74-6.14,12.9-12.16,16.35-3.4,1.95-4.19-.46-4.16-3.37.03-3.71-.51-7.41-.38-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m169.29,375.11c3.55-16.35,16.42-30.33,32.42-35.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m169.91,360.5c-.31-3.63-1.5-7.29-3.97-9.97-4.22-4.58-11.4-5.57-15.44-10.31-2.47-2.9-3.85-7.21-7.49-8.33-3.27-1.01-6.6,1.15-9.97,1.75-2.3.41-4.69.08-7,.47-2.31.4-4.72,1.87-5.04,4.19-.38,2.74,2.3,4.94,4.91,5.86,2.61.92,5.55,1.23,7.66,3.02,2.29,1.95,3.07,5.21,5.23,7.3,3.68,3.56,9.85,2.53,14.34,5,6.21,3.43,6.8,12.56,12.98,15.71,3.5,1.78,4.16-.67,3.98-3.58-.22-3.7.13-7.42-.19-11.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m167.04,372.94c-4.38-16.14-17.96-29.44-34.19-33.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m149.92,349.94c.97-4.79,5.76-7.83,7.73-12.3,1.76-3.99,1.07-8.57.77-12.92-.3-4.35.04-9.23,3.19-12.24,2.52-2.4,6.27-3.04,9.01-5.19,2.12-1.67,3.47-4.1,5.22-6.15,1.76-2.05,4.31-3.81,6.97-3.33,2.82.51,4.66,3.48,4.85,6.34.19,2.86-.88,5.64-1.92,8.31-1.05,2.67-2.11,5.45-1.92,8.31.44,6.47,7.15,11.54,6.63,18.01-.35,4.37-3.94,7.73-7.49,10.3-3.56,2.57-7.53,5.03-9.37,9.01-2.34,5.04.34,20.55-9.24,14.22-5.93-3.92-15.97-14.72-14.43-22.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m167.09,376.53s-8.15-36.37,11.01-68.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m183.93,365.22h-.07c0,.62-6.91,1.12-15.43,1.12s-15.43-.5-15.43-1.12h-.07s-9.22,5.87-9.22,13.41,9.08,11.45,9.08,11.45h31.29s9.08-3.91,9.08-11.45-9.22-13.41-9.22-13.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m191.4,384.13c-2.64,3.93-7.33,5.96-7.33,5.96h-31.29s-9.08-3.91-9.08-11.45c0-3.84,2.4-7.25,4.75-9.67.04.97.3,1.92.82,2.83,1.51,2.68,4.37,4.29,7.19,5.53,10.93,4.83,22.94,6.18,34.95,6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m191.4,384.13c-2.64,3.93-7.33,5.96-7.33,5.96h-31.29s-9.08-3.91-9.08-11.45c0-3.84,2.4-7.25,4.75-9.67.04.97.3,1.92.82,2.83,1.51,2.68,4.37,4.29,7.19,5.53,10.93,4.83,22.94,6.18,34.95,6.81Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 621.21,
    cy: 212.68,
    r: 30.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 621.21,
    cy: 212.68,
    r: 23.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 621.21,
    cy: 212.68,
    r: 17.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 621.21,
    cy: 212.68,
    r: 10.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m625.37,212.68c0,2.3-1.86,4.16-4.16,4.16s-4.16-1.86-4.16-4.16,1.86-4.16,4.16-4.16,4.16,1.86,4.16,4.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m637.86,196.02h0c-.65-.65-1.7-.65-2.35,0l-14.3,14.3c-.65.65-.65,1.7,0,2.35h0c.65.65,1.7.65,2.35,0l14.3-14.3c.65-.65.65-1.7,0-2.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "634.92 198.97 651.33 182.56 650.15 177.85 636.15 191.85 634.92 198.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "634.92 198.97 651.33 182.56 656.04 183.73 642.03 197.74 634.92 198.97"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m232.64,291.97h-39.33c-3.22,0-6.44-2.61-7.18-5.83l-7.23-31.33c-.74-3.22,1.26-5.83,4.49-5.83h39.33c3.22,0,6.44,2.61,7.18,5.83l7.23,31.33c.74,3.22-1.26,5.83-4.49,5.83Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "187.24 263.89 189.99 266.06 194.12 260.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 199.2,
    y1: 261.56,
    x2: 225.11,
    y2: 261.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 200.1,
    y1: 265.47,
    x2: 214.18,
    y2: 265.47
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "190.7 278.89 193.45 281.06 197.58 275.68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 202.66,
    y1: 276.56,
    x2: 228.58,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 203.56,
    y1: 280.47,
    x2: 217.65,
    y2: 280.47
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 212.66,
    y: 128.97,
    width: 31.83,
    height: 29.89,
    rx: 8.08,
    ry: 8.08,
    transform: "translate(457.15 287.84) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "231.33 158.86 239.66 164.95 238.99 158.86 231.33 158.86"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m233.88,146.65c-1.75-1.24-2.33-.2-3.44,1s-3.83-1.9-3.83-1.9c0,0-2.73-3.1-1.4-4.04,1.33-.94,2.44-1.38,1.43-3.28-.95-1.79-1.81-2.73-2.39-2.71-.57.01-1.36.76-1.95,1.29-.58.53-3.83,4.19,1.98,10.79,5.8,6.6,9.85,3.86,10.45,3.35.6-.51,1.44-1.2,1.53-1.77.08-.57-.73-1.54-2.39-2.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m549.28,205.89h18.67c3.63,0,6.58,2.95,6.58,6.58v16.73c0,3.63-2.95,6.58-6.58,6.58h-18.67c-3.63,0-6.58-2.95-6.58-6.58v-16.73c0-3.63,2.95-6.58,6.58-6.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "555.87 235.78 547.53 241.86 548.2 235.78 555.87 235.78"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m567,224.06l.42-1.9c.09-.4-.16-.79-.56-.88l-1.17-.26c-.3-.07-.53-.31-.57-.62-.06-.48-.17-.95-.33-1.41-.1-.29,0-.62.24-.81l.93-.75c.32-.26.37-.72.11-1.04l-1.23-1.51c-.26-.32-.72-.37-1.04-.11l-.93.75c-.24.19-.58.22-.84.06-.2-.12-.41-.24-.63-.34-.22-.1-.44-.19-.67-.27-.29-.1-.49-.38-.49-.69v-1.2c-.01-.41-.34-.74-.75-.73h-1.95c-.41.02-.74.35-.73.76v1.2c.01.31-.18.59-.47.7-.45.16-.89.38-1.3.64-.26.17-.6.14-.84-.05l-.94-.74c-.32-.25-.79-.2-1.04.12l-1.2,1.53c-.25.32-.2.79.12,1.04l.94.74c.24.19.35.51.25.81-.16.46-.26.94-.31,1.41-.03.31-.26.56-.56.63l-1.16.27c-.4.09-.64.49-.55.89l.45,1.9c.09.4.49.64.89.55l1.16-.27c.3-.07.62.05.79.31.26.4.56.78.91,1.12.22.22.27.55.14.83l-.51,1.08c-.17.37-.02.81.35.98l1.76.83c.37.17.81.02.98-.35l.51-1.08c.13-.28.42-.45.73-.42.48.05.97.05,1.45-.01.31-.04.6.13.74.41l.53,1.07c.18.37.62.52.99.34l1.75-.86c.37-.18.52-.62.34-.99l-.53-1.07c-.14-.28-.09-.61.13-.83.33-.34.63-.72.89-1.14.16-.26.48-.39.78-.32l1.17.26c.4.09.79-.16.88-.56Zm-10.01.47c-1.84-.87-2.62-3.06-1.75-4.9.87-1.84,3.06-2.62,4.9-1.75,1.84.87,2.62,3.06,1.75,4.9-.87,1.84-3.06,2.62-4.9,1.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m493.82,191.67c1.24-3.95,1.92-8.24,1.92-12.71,0-19.91-13.22-36.27-29.81-36.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m491.91,191.67c1.24-3.95,1.92-8.24,1.92-12.71,0-19.91-13.22-36.27-29.81-36.27"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m492.71,198.69s-3.22,18.68-27.25,18.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m459.15,217.46c.11,1.72,2.94,2.94,6.33,2.73,3.39-.21,6.05-1.78,5.94-3.49-.11-1.72-2.94-2.94-6.33-2.73-3.39.21-6.05,1.78-5.94,3.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 483.49,
    y: 178.69,
    width: 20.05,
    height: 27.27,
    rx: 8.97,
    ry: 8.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 487.77,
    y: 182.35,
    width: 14.66,
    height: 19.94,
    rx: 5.42,
    ry: 5.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 488.26,
    y: 182.35,
    width: 14.66,
    height: 19.94,
    rx: 5.42,
    ry: 5.42
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m500.21,183.09c.52,4.33.66,14.9-9.64,18.22.88.62,1.95.98,3.1.98h3.82c2.99,0,5.42-2.43,5.42-5.42v-9.1c0-2-1.09-3.75-2.71-4.69Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 308.13,
    y: 136.62,
    width: 95,
    height: 38.67,
    rx: 14,
    ry: 14
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m388.22,152.12l-.82,1.66c-.12.24-.34.4-.6.44l-1.83.27c-.65.09-.91.9-.44,1.36l1.32,1.29c.19.18.27.45.23.7l-.31,1.82c-.11.65.57,1.15,1.16.84l1.63-.86c.23-.12.51-.12.74,0l1.63.86c.58.31,1.27-.19,1.16-.84l-.31-1.82c-.04-.26.04-.52.23-.7l1.32-1.29c.47-.46.21-1.26-.44-1.36l-1.83-.27c-.26-.04-.48-.2-.6-.44l-.82-1.66c-.29-.59-1.14-.59-1.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m371.57,152.12l-.82,1.66c-.12.24-.34.4-.6.44l-1.83.27c-.65.09-.91.9-.44,1.36l1.32,1.29c.19.18.27.45.23.7l-.31,1.82c-.11.65.57,1.15,1.16.84l1.63-.86c.23-.12.51-.12.74,0l1.63.86c.58.31,1.27-.19,1.16-.84l-.31-1.82c-.04-.26.04-.52.23-.7l1.32-1.29c.47-.46.21-1.26-.44-1.36l-1.83-.27c-.26-.04-.48-.2-.6-.44l-.82-1.66c-.29-.59-1.14-.59-1.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m354.92,152.12l-.82,1.66c-.12.24-.34.4-.6.44l-1.83.27c-.65.09-.91.9-.44,1.36l1.32,1.29c.19.18.27.45.23.7l-.31,1.82c-.11.65.57,1.15,1.16.84l1.63-.86c.23-.12.51-.12.74,0l1.63.86c.58.31,1.27-.19,1.16-.84l-.31-1.82c-.04-.26.04-.52.23-.7l1.32-1.29c.47-.46.21-1.26-.44-1.36l-1.83-.27c-.26-.04-.48-.2-.6-.44l-.82-1.66c-.29-.59-1.14-.59-1.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m338.26,152.12l-.82,1.66c-.12.24-.34.4-.6.44l-1.83.27c-.65.09-.91.9-.44,1.36l1.32,1.29c.19.18.27.45.23.7l-.31,1.82c-.11.65.57,1.15,1.16.84l1.63-.86c.23-.12.51-.12.74,0l1.63.86c.58.31,1.27-.19,1.16-.84l-.31-1.82c-.04-.26.04-.52.23-.7l1.32-1.29c.47-.46.21-1.26-.44-1.36l-1.83-.27c-.26-.04-.48-.2-.6-.44l-.82-1.66c-.29-.59-1.14-.59-1.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m321.61,152.12l-.82,1.66c-.12.24-.34.4-.6.44l-1.83.27c-.65.09-.91.9-.44,1.36l1.32,1.29c.19.18.27.45.23.7l-.31,1.82c-.11.65.57,1.15,1.16.84l1.63-.86c.23-.12.51-.12.74,0l1.63.86c.58.31,1.27-.19,1.16-.84l-.31-1.82c-.04-.26.04-.52.23-.7l1.32-1.29c.47-.46.21-1.26-.44-1.36l-1.83-.27c-.26-.04-.48-.2-.6-.44l-.82-1.66c-.29-.59-1.14-.59-1.43,0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "323.71 173.79 320.37 182.79 333.46 172.95 323.71 173.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m218.17,213.49h-62c-3.87,0-7.72-3.13-8.62-7l-3.39-14.67c-.89-3.87,1.52-7,5.38-7h62c3.87,0,7.72,3.13,8.62,7l3.39,14.67c.89,3.87-1.52,7-5.38,7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 154.32,
    y1: 194.66,
    x2: 179.32,
    y2: 194.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 185.4,
    y1: 194.66,
    x2: 192.32,
    y2: 194.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 156.4,
    y1: 203.66,
    x2: 199.9,
    y2: 203.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 206.48,
    y1: 203.66,
    x2: 213.4,
    y2: 203.66
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m369.96,278.84h-57.33c-3.31,0-6.62-2.69-7.39-6l-14.47-62.67c-.77-3.31,1.3-6,4.61-6h57.33c3.31,0,6.62,2.69,7.39,6l14.47,62.67c.77,3.31-1.3,6-4.61,6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 302.08,
    y1: 215.68,
    x2: 325.83,
    y2: 215.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m307.6,227.25c.18.79-.31,1.42-1.09,1.42s-1.57-.64-1.75-1.42c-.18-.79.31-1.42,1.09-1.42s1.57.64,1.75,1.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 312.5,
    y1: 227.25,
    x2: 339.75,
    y2: 227.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 345.88,
    y1: 227.25,
    x2: 351.13,
    y2: 227.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m309.85,237c.18.79-.31,1.42-1.09,1.42s-1.57-.64-1.75-1.42.31-1.42,1.09-1.42,1.57.64,1.75,1.42Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 314.75,
    y1: 237,
    x2: 349.75,
    y2: 237
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m312.1,246.75c.18.79-.31,1.42-1.09,1.42s-1.57-.64-1.75-1.42c-.18-.79.31-1.42,1.09-1.42s1.57.64,1.75,1.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 317.01,
    y1: 246.75,
    x2: 327.01,
    y2: 246.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 333.01,
    y1: 246.75,
    x2: 355.63,
    y2: 246.75
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 318.49,
    y1: 253.18,
    x2: 337.86,
    y2: 253.18
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "565.41 168.78 563.08 182.35 581.41 167.29 565.41 168.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 549.68,
    y: 109.74,
    width: 97.33,
    height: 61.33,
    rx: 15.33,
    ry: 15.33
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-39",
    transform: "translate(569.68 148.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24/7")))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSupport);
export default __webpack_public_path__ + "static/media/img-support.bcb3b57138106fee34b3d3592c999c25.svg";
export { ForwardRef as ReactComponent };